import React from 'react';
import PropTypes from 'prop-types';

import {Paper, Stack, Typography} from 'views/components';
import {PlaceOutlined} from 'views/icons';
import {Translate} from 'views/module';

const LocationCard = (props) => {
  const {location} = props;

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        borderRadius: 3,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center" sx={{mb: 1}}>
        <PlaceOutlined fontSize="small" />
        <Typography variant="body2" sx={{fontWeight: 700}}>
          <Translate expression='jobDetail.Location' />
        </Typography>
      </Stack>

      <Typography variant="body2" sx={{fontWeight: 700, color: 'text.secondary'}}>
        <Translate
          expression="jobBoard.JobListings.JobTitle"
          substitute={{
            neighborhood: location.neighborhood,
            city: location.city,
          }}
        />
      </Typography>
    </Paper>
  );
};

LocationCard.propTypes = {
  location: PropTypes.object.isRequired,
};

export default LocationCard;
